import React from 'react';
import { colors } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

export default function UnverifiedIcon(props) {
  return <ErrorOutlineIcon style={{ color: colors.red[400] }} {...props} />;
}
